/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

const endPoint = process.env.VUE_APP_ENDPOINT_V2 || `https://invoicegun.strategio.dev`

const callApi = async (uri: string, options: RequestInit): Promise<Response> => {
    const url = endPoint + uri
    const info: RequestInit = {
        ...options,
        headers: {
            ...options?.headers,
            'Content-Type': 'application/json'
        }
    }

    return await fetch(url, info)
}

export const useSf = () => {
    return {
        callApi
    }
}